var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.audit && _vm.audit.category && _vm.audit.category.responseType != 'ProductAudit')?_c('div',{staticClass:"pa-10px"},[(_vm.loading)?_c('loader',{attrs:{"centered":true}}):_c('div',[_c('v-calendar',{ref:"calendar",attrs:{"weekdays":[1, 2, 3, 4, 5, 6, 0],"type":"month","events":_vm.events}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }